/*
These functions make sure WordPress
and Foundation play nice together.
*/

jQuery(document).ready(function($) {
	
	// Remove empty P tags created by WP inside of Accordion and Orbit
	$('.accordion p:empty, .orbit p:empty').remove();

	// Convert YouTube watch URLs to embed format for iframe with id="video-url"
	var $videoIframe = $('#video-url');
	if ($videoIframe.length && $videoIframe.is('iframe')) {
		var currentSrc = $videoIframe.attr('src');
		
		if (currentSrc && typeof currentSrc === 'string') {
			var newSrc = currentSrc;
			
			// Convert https://www.youtube.com/watch?v=VIDEO_ID to https://www.youtube.com/embed/VIDEO_ID?feature=oembed
			newSrc = newSrc.replace(/(https?:\/\/)?(www\.)?youtube\.com\/watch\?v=([^&"'\s]+)/gi, function(match, protocol, www, videoId) {
				protocol = protocol || 'https://';
				www = www || 'www.';
				return protocol + www + 'youtube.com/embed/' + videoId + '?feature=oembed';
			});
			
			// Convert https://youtu.be/VIDEO_ID to https://www.youtube.com/embed/VIDEO_ID?feature=oembed
			newSrc = newSrc.replace(/(https?:\/\/)?youtu\.be\/([^?&"'\s]+)/gi, function(match, protocol, videoId) {
				protocol = protocol || 'https://';
				return protocol + 'www.youtube.com/embed/' + videoId + '?feature=oembed';
			});
			
			// Update iframe src if URL was converted
			if (newSrc !== currentSrc) {
				$videoIframe.attr('src', newSrc);
			}
		}
	}

	// Adds Flex Video to YouTube and Vimeo Embeds
	$('iframe[src*="youtube.com"], iframe[src*="vimeo.com"]').each(function() {
		if ( $(this).innerWidth() / $(this).innerHeight() > 1.5 ) {
			$(this).wrap("<div class='widescreen responsive-embed'/>");
		} else {
			$(this).wrap("<div class='responsive-embed'/>");
		}
	});
	
	//Prevent Dropdown buttons in Main Nav from doing anything when clicked
	$('.menu-item a[href="#"]').on('click', function(event) {
		event.preventDefault();
	  });
	
function initCarousel($carousel) {
  let currentSlide = 0;
  const $wrapper = $carousel.find('.kt-row-column-wrap').first();
  let isProgrammaticScroll = false;
  let isAnimating = false; // Track animation state

  function getSlides() {
    return $wrapper.find('> .wp-block-kadence-column');
  }

  function getTotalSlides() {
    return getSlides().length;
  }

  // Initialize total slide count
  $carousel.find('.total-slides').text(getTotalSlides());

  function goToSlide(index) {
    if (isAnimating) return; // Prevent interruptions
    
    const $slides = getSlides();
    const slideWidth = $slides[0].getBoundingClientRect().width;
    const computedStyle = window.getComputedStyle($wrapper[0]);
    const gap = parseInt(computedStyle.columnGap || computedStyle.gap || 0);
    const offset = index * (slideWidth + gap);

    isProgrammaticScroll = true;
    isAnimating = true;

    $wrapper.animate({ scrollLeft: offset }, 300, function() {
      isProgrammaticScroll = false;
      isAnimating = false;
      currentSlide = index; // Update only after animation completes
      $carousel.find('.current-slide').text(currentSlide + 1);
    });
  }

  $carousel.find('.next-btn').on('click', function() {
    if (currentSlide < getTotalSlides() - 1 && !isAnimating) {
      goToSlide(currentSlide + 1);
    }
  });

  $carousel.find('.prev-btn').on('click', function() {
    if (currentSlide > 0 && !isAnimating) {
      goToSlide(currentSlide - 1);
    }
  });

  $wrapper.on('scroll', function() {
    if (isProgrammaticScroll) return;

    const $slides = getSlides();
    const slideWidth = $slides[0].getBoundingClientRect().width;
    const computedStyle = window.getComputedStyle($wrapper[0]);
    const gap = parseInt(computedStyle.columnGap || computedStyle.gap || 0);
    const scrollLeft = $wrapper.scrollLeft();
    const index = Math.round(scrollLeft / (slideWidth + gap));

    if (index !== currentSlide) {
      currentSlide = index;
      $carousel.find('.current-slide').text(currentSlide + 1);
    }
  });
}

$('.mobile-carousel').each(function() {
  initCarousel($(this));
});

if (window.location.pathname === '/sitemap' || window.location.pathname === '/sitemap/') {
		$('#primary').css({
		  'max-width': '1200px',
		  'margin': '150px auto 48px',
		  'padding': '0 15px'
		});

		$('#content').css({
		  'list-style-type': 'none'
		});

		$('#content li a').css({
		  'color': '#212529',
		  'word-break': 'break-all'
		});

		$('#content li a').hover(
			function () {
				$(this).css('color', '#6B4AED');
			  $(this).css('text-decoration', 'underline');
			},
			function () {
				$(this).css('color', '#212529');
			  $(this).css('text-decoration', 'none');
			}
		  );
	  
		$('#content').prepend('<h1>Sitemap</h1>');
		
		$('#content h1').css({
			'color': '#0F8BD1',
			'margin-bottom': '32px'
		});
	}

	const assistedLivingPrices = {
      AL: "$3503.00", AK: "$6830.00", AZ: "$4000.00", AR: "$3760.00", CA: "$5250.00",
      CO: "$4750.00", CT: "$5129.00", DE: "$5995.00", FL: "$4000.00", GA: "$3535.00",
      HI: "$5375.00", ID: "$3838.00", IL: "$4488.00", IN: "$4283.00", IA: "$4367.00",
      KS: "$5500.00", KY: "$3448.00", LA: "$3748.00", ME: "$5865.00", MD: "$4900.00",
      MA: "$6500.00", MI: "$4250.00", MN: "$4508.00", MS: "$3500.00", MO: "$3000.00",
      MT: "$4450.00", NE: "$6000.00", NV: "$3750.00", NH: "$6053.00", NJ: "$6495.00",
      NM: "$4498.00", NY: "$4580.00", NC: "$4010.00", ND: "$3391.00", OH: "$4635.00",
      OK: "$3855.00", OR: "$5045.00", PA: "$4100.00", RI: "$6826.00", SC: "$3612.00",
      SD: "$3350.00", TN: "$4105.00", TX: "$3998.00", UT: "$3500.00", VT: "$5250.00",
      VA: "$5250.00", WA: "$6000.00", WV: "$4160.00", WI: "$4600.00", WY: "$4169.00"
    };

	const memoryCarePrices = {
  AL: "$4098.51", AK: "$7991.10", AZ: "$4680.00", AR: "$4399.20", CA: "$6142.50",
  CO: "$5557.50", CT: "$6000.93", DE: "$7014.15", FL: "$4680.00", GA: "$4135.95",
  HI: "$6288.75", ID: "$4490.46", IL: "$5250.96", IN: "$5011.11", IA: "$5109.39",
  KS: "$5358.60", KY: "$4034.16", LA: "$4385.16", ME: "$6862.05", MD: "$5733.00",
  MA: "$7605.00", MI: "$4972.50", MN: "$5274.36", MS: "$4095.00", MO: "$3510.00",
  MT: "$5206.50", NE: "$8000.00", NV: "$4387.50", NH: "$7082.01", NJ: "$7599.15",
  NM: "$5262.66", NY: "$5358.60", NC: "$4691.70", ND: "$3967.47", OH: "$5422.95",
  OK: "$4510.35", OR: "$5902.65", PA: "$4797.00", RI: "$7986.42", SC: "$6,500",
  SD: "$3919.50", TN: "$4802.85", TX: "$4677.66", UT: "$4095.00", VT: "$6142.50",
  VA: "$6142.50", WA: "$7020.00", WV: "$4867.20", WI: "$5382.00", WY: "$4877.73"
};

const nursingHomePrices = {
  AL: "$6676.00", AK: "$31512.00", AZ: "$6540.00", AR: "$6083.00", CA: "$9794.00",
  CO: "$8567.00", CT: "$13764.00", DE: "$12273.00", FL: "$10494.00", GA: "$8654.00",
  HI: "$12501.00", ID: "$8517.00", IL: "$6266.00", IN: "$7270.00", IA: "$6874.00",
  KS: "$6296.00", KY: "$7178.00", LA: "$5759.00", ME: "$10949.00", MD: "$10342.00",
  MA: "$12623.00", MI: "$9095.00", MN: "$11601.00", MS: "$7118.00", MO: "$5262.00",
  MT: "$7574.00", NE: "$10000.00", NV: "$9216.00", NH: "$10950.00", NJ: "$11254.00",
  NM: "$7604.00", NY: "$12775.00", NC: "$7483.00", ND: "$11978.00", OH: "$7300.00",
  OK: "$5475.00", OR: "$10342.00", PA: "$10403.00", RI: "$9429.00", SC: "$7285.00",
  SD: "$7118.00", TN: "$7148.00", TX: "$5125.00", UT: "$7178.00", VT: "$10585.00",
  VA: "$8213.00", WA: "$9429.00", WV: "$11619.00", WI: "$9022.00", WY: "$6996.00"
};

function costForm($input, priceData, $resultOutput) {
  $(function() {
    const inputVal = $input.text().trim().toUpperCase();
    const price = priceData[inputVal];
    $resultOutput.text(
      price
        ? price
        : ''
    );
  });
}

// Assisted Living
costForm(
  $('#cost-form.assisted-living-cost'),
  assistedLivingPrices,
  $('#cost-form-result.assisted-living-result')
);

// Memory Care
costForm(
  $('#cost-form.memory-care-cost'),
  memoryCarePrices,
  $('#cost-form-result.memory-care-result')
);

// Nursing Home
costForm(
  $('#cost-form.nursing-home-cost'),
  nursingHomePrices,
  $('#cost-form-result.nursing-home-result')
);

// Element: "Read More" Toggle Buttons
	var instance = ['1', '2', '3', '4', '5', '6', '7', '8', '9' ];
	$.each( instance, function( i, val ) {
		$('.toggle-' + val).click(function(e){
			e.preventDefault();
			$('.showHide-' + val).slideToggle();
			$(this).text( $(this).text() == 'read more' ? "read less" : "read more");
			$(this).toggleClass('show-active');
		});
	});

  // Element: Mobile "Read More" Toggle Buttons
  if ($(window).width() < 640) {
	$('.mobile-toggle').click(function(e){
		e.preventDefault();
		$(this).toggleClass('mobile-show-active');
		$(this).closest('.mobile-dropdown').find('.mobile-showHide').first().slideToggle();
	});
}

  function initStickyLabel() {
  if ($(window).width() > 1200) {
    var $label = $('#input_3_13 label.gform-field-label'); // your sticky label
    var $form = $('#gform_3'); // form container
    var $stopField = $('#field_3_18'); // the field where the label should stop
    let $offset = 45;

    if (window.location.pathname === '/tools/care-assessment-tool/') {
      $offset = 10;
    }
    console.log('Offset is ' + $offset);

    // Ensure form is positioned
    if ($form.css('position') === 'static') {
      $form.css('position', 'relative');
    }

    var initialTop = parseInt($label.css('top'), 10) || 0;
    var labelHeight = $label.outerHeight();

    function updateLabel() {
      var scrollTop = $(window).scrollTop();
      var formTop = $form.offset().top;
      var stopBottom = $stopField.offset().top + $stopField.outerHeight();
      var maxTranslate = stopBottom - formTop - labelHeight - initialTop;

      // Calculate translateY for smooth scroll
      var translateY = scrollTop - formTop + Math.abs(initialTop) - $offset;
      if (translateY < 0) translateY = 0;
      if (translateY > maxTranslate) translateY = maxTranslate;

      $label.css({
        transform: 'translateY(' + translateY + 'px)',
        width: $form.width() + 'px' // keep it responsive
      });
    }

    // Bind events + do the initial call INSIDE the if block
    $(window).on('scroll resize', updateLabel);
    updateLabel(); // initial call
  }
}

 $('#gform_wrapper_3 input[type="radio"]:disabled').each(function(){
        $(this).prop('disabled', false);
    });

    if (window.location.pathname === '/tools/care-assessment-tool/') { // change to your path
        $('input[name="input_21"][value="Yes"]').prop('checked', true);
        $("#care-assessment-form").addClass("radios-active");
        initStickyLabel();
        setTimeout(function() {
    $(window).trigger('scroll');
  }, 50);
    }

    $('#choice_3_21_0').on('click', function() {
      $("#care-assessment-form").addClass("radios-active");
      initStickyLabel();
      setTimeout(function() {
    $(window).trigger('scroll');
  }, 50); // tweak timing if needed
  if (window.matchMedia('(min-width: 1200px)').matches && $('#contact-form').length) {
      $("#care-assessment-form").css("min-height", "1359px");
  }
    });

    $('#choice_3_21_1').on('click', function() {
      $("#care-assessment-form").removeClass("radios-active");
  if (window.matchMedia('(min-width: 1200px)').matches && $('#contact-form').length) {
      $("#care-assessment-form").css("min-height", "1150px");
  }
    });


    const secondCols = document.querySelectorAll('.second-column');
    let currentTop;
    let margin = 100;
    let extraSpace = 90;
    let lessSpace = 70;

    if ($('#contact-form').length) {
      currentTop = 85;
    } else {
      currentTop = 45;
    }
    
  secondCols.forEach(el => {
    el.style.top = currentTop + 'px';
    // Wait for layout/rendering, then get height
    const height = el.offsetHeight;
    
    if (el.classList.contains('extra-space')) {
      currentTop += height + extraSpace;
    } else if (el.classList.contains('less-space')) {
      currentTop += height + lessSpace;
    }
    else {
      currentTop += height + margin;
    }
  });

  $('#input_3_13 label.gform-field-label').on('click', function(e) {
    e.preventDefault();
  });

  function setCareAssessmentMinHeight() {
  if (window.matchMedia('(min-width: 1200px)').matches && $('#contact-form').length) {
    let $formContainer = $('#care-assessment-form');
    let $careForm = $formContainer.find('#contact-form');
    let childHeight = $careForm.outerHeight(true) + 80; // true includes margins, add 80px
    $formContainer.css('min-height', childHeight + 'px');
  }
  }

  if (window.matchMedia('(min-width: 1200px)').matches && $('#contact-form').length) {
    setTimeout(setCareAssessmentMinHeight, 100);
  }

  function calculateTotal() {
    let total = 0;

    // Loop through each selected radio input with class 'score-radio'
    $('.second-column input[type="radio"]:checked').each(function() {
      let val = parseInt($(this).val());
      if (!isNaN(val)) {
        total += val;
      }
    });

    // Update the hidden field (optional)
    $('#input_3_26').val(total);

    // Update the result text based on total
    let resultText = '';
    if (total <= 5) {
      resultText = 'Low score result text.';
    } else if (total <= 8) {
      resultText = 'Medium score result text.';
    } else {
      resultText = 'High score result text.';
    }

    $('.score-result').html('<strong>' + resultText + '</strong>');
  }

  // Trigger calculation whenever a radio button is changed
  $(document).on('change', '.second-column input[type="radio"]', calculateTotal);

  // Trigger on page load too (in case of pre-filled values)
  calculateTotal();

  function areaShowMoreButton($section) {
    const $inside = $section.find('.as-show-more-btn');
    if ($inside.length) {
      return $inside;
    }

    // Pill layouts put the button in the next column, outside .areas-served.
    const $nextCol = $section.nextAll('.wp-block-kadence-column').filter(function () {
      return $(this).find('.as-show-more-btn').length && !$(this).find('ul').length;
    }).first();

    return $nextCol.find('.as-show-more-btn');
  }

  $('.areas-served').each(function () {
    const $section = $(this);
    const $list = $section.find('ul').first();
    if (!$list.length) {
      return;
    }

    const $showMoreBtn = areaShowMoreButton($section);

    // Big link buttons always show every city. Bullet .city-list keeps View More.
    if (!$list.hasClass('city-list')) {
      $showMoreBtn.each(function () {
        const $button = $(this);
        const $col = $button.closest('.wp-block-kadence-column');

        if ($col.length && !$col.hasClass('areas-served') && !$col.closest('.areas-served').length) {
          $col.hide();
        } else {
          $button.hide();
        }
      });
      return;
    }

    const itemCount = $list.children('li').length;
    if (itemCount > 25) {
      $list.addClass('big-list show-all-list');
      $showMoreBtn.show();
    } else if (itemCount > 5) {
      $list.addClass('big-list');
      $showMoreBtn.show();
    } else {
      $showMoreBtn.hide();
    }
  });

  $('.as-show-more-btn').on('click', function () {
    const $btn = $(this);
    let $grid = $btn.closest('.areas-served').find('ul.city-list').first();

    if (!$grid.length) {
      $grid = $btn.closest('.wp-block-kadence-column').prevAll('.areas-served').first().find('ul.city-list').first();
    }

    if (!$grid.length) {
      return;
    }

    $grid.toggleClass('expanded');

    if ($grid.hasClass('expanded')) {
      $btn.text('View Less');
    } else {
      $btn.text('View More');
    }

    $btn.toggleClass('active');
  });

const $testimonialLists = $('.advisors-testimonials');
const $tShowMoreBtn = $('.t-show-more-btn');

// First list is always active
const $firstList = $testimonialLists.eq(0);

// Hide after 2nd item for the first list
if ($firstList.children('div').length > 2) {
  $firstList.children('div:gt(1)').hide();
  $tShowMoreBtn.show();
} else {
  $tShowMoreBtn.hide();
}

// If there is a second list, apply mobile-specific logic
if ($testimonialLists.length > 1) {
  const $secondList = $testimonialLists.eq(1);

  if (window.matchMedia("(max-width: 640px)").matches) {
    // On mobile, hide all in the second list, show first two
    $secondList.children('div').hide().slice(0, 2).show();
    
    // Show button only if there are more than 2
    if ($secondList.children('div').length > 2) {
      $tShowMoreBtn.show();
    }
  }
}

// Show More / Show Less toggle (works for whichever list is visible)
$tShowMoreBtn.on('click', function () {
  let $activeList;

  if (window.matchMedia("(max-width: 640px)").matches && $testimonialLists.length > 1) {
    $activeList = $testimonialLists.eq(1); // second list on mobile
  } else {
    $activeList = $testimonialLists.eq(0); // first list otherwise
  }

  const $hiddenTestimonials = $activeList.children('div:gt(1)');

  $hiddenTestimonials.slideToggle();

  if ($(this).hasClass('active')) {
    $(this).removeClass('active').text('Show More');
  } else {
    $(this).addClass('active').text('Show Less');
  }
});


function runOnValidationError(formId) {
    // Check if there are any validation errors on the form
    if ($('#gform_' + formId + ' .gfield_error').length > 0 && $('#choice_3_21_0').is(':checked')) {
      // Run your custom function
      console.log('Validation error detected!');
      $("#care-assessment-form").addClass("radios-active");
      if (window.matchMedia('(min-width: 1200px)').matches && $('#contact-form').length) {
      $("#care-assessment-form").css("min-height", "1359px");
    }
    }
  }

  // This runs every time a form is rendered or re-rendered (including failed submissions)
  $(document).on('gform_post_render', function(event, formId) {
    runOnValidationError(formId);
  });

  function setupZipValidation(inputSelector, formId) {
    var $zipInput = $(inputSelector);

    // Flag if GF validation container already exists
    var hasGFValidation = $("#gform_" + formId + "_validation_container").length > 0;

    var $errorMsg;
    if (!hasGFValidation) {
        // Only create/show our custom error if GF isn't already handling errors
        $errorMsg = $('<div class="gfield_description validation_message" style="display:none; height:0;">Please enter a valid 5-digit ZIP code</div>');
        $zipInput.after($errorMsg);
    }

    var hideTimeout;

    $zipInput.on('input', function() {
        var val = this.value;
        var valid = /^\d{0,5}$/.test(val); // allow 0 to 5 digits only

        if (!valid) {
            if (!hasGFValidation && $errorMsg) {
                $errorMsg.show();

                clearTimeout(hideTimeout);

                // Hide error after 1.5s
                hideTimeout = setTimeout(function() {
                    $errorMsg.fadeOut();
                }, 1500);
            }

            // Remove invalid chars and trim to 5 digits
            this.value = val.replace(/\D/g, '').slice(0, 5);
        } else {
            if (!hasGFValidation && $errorMsg) {
                clearTimeout(hideTimeout);
                $errorMsg.hide();
            }
        }
    });
}

// Call with formId so we know which validation container to check
setupZipValidation('#input_2_8_5', 2); 
setupZipValidation('#input_3_8_5', 3);

    function checkWrap() {
  var winWidth = $(window).width();

  if (winWidth <= 640) {
    var $container = $('#pre-nav');
    var $header = $('header.header');
    var $children = $container.children();

    if ($children.length === 0) return;

    var firstRowTop = $children.first().position().top;
    var wrapped = false;

    $children.each(function() {
      if ($(this).position().top > firstRowTop) {
        wrapped = true;
        return false; // break loop
      }
    });

    $container.css('justify-content', wrapped ? 'center' : 'space-between');
    $header.css({
      'min-height': wrapped ? '62px' : '36px',
      'max-height': wrapped ? '62px' : '36px'
    });
  } 
}

$(window).on('resize', checkWrap);
$(document).ready(checkWrap);

if (window.location.href === "https://san-antonio-north.assistedlivinglocators.com/about-us/") {
    $(".about-us.social").after('<p><a href="mailto:loriy@assistedlivinglocators.com" aria-label="Contact us at loriy@assistedlivinglocators.com" class="manrope-unique5"><i class="fa-solid fa-envelope"></i> loriy@assistedlivinglocators.com</a></p><p><a href="mailto:johny@assistedlivinglocators.com" aria-label="Contact us at johny@assistedlivinglocators.com" class="manrope-unique5"><i class="fa-solid fa-envelope"></i> johny@assistedlivinglocators.com</a></p>');
}

$('p').each(function() {
    if ($(this).html().trim() === '' || $(this).html().trim() === '&nbsp;') {
      $(this).remove();
    }
  });

  if (window.location.hostname.includes('omaha.assistedlivinglocators.com')) {

    $('body *').contents().filter(function() {
      return this.nodeType === 3 && this.nodeValue.includes('Lavista NE');
    }).each(function() {
      this.nodeValue = this.nodeValue.replace(/Lavista NE/g, 'LaVista NE');
    });

  }

}); 
